import React from 'react'
import accentureLogo from  'assets/accentureLogo.png'

const TopBar = () => {
    return (
        <div className="flex w-100 pb-3 items-stretch justify-items-center">
            <div className="">
                <img src={accentureLogo} alt="" className="w-32" />
            </div>

            <div className="flex flex-col justify-items-center pl-2 pt-2">
                <p className="inline-block text-3xl h-full align-middle">+</p>
            </div>

            <div className="flex flex-col justify-items-center pl-2 pt-2 font-bold">
                <p className="inline-block text-3xl align-middle">MagicBox</p>
            </div>
        </div>
    )
}

export default TopBar
